import useAuthSelector from 'modules/shared/hooks/useAuthSelector';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authActions, isSessionExpired, startSession } from 'store/auth';

const useSession = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { token, expiryInMinutes } = useAuthSelector();

    /******************** Listeners ********************/
    useEffect(() => {
        if (!token) return;

        const docListenerFn = () => {
            startSession(expiryInMinutes);
        };

        const events = ['click', 'keydown'];

        events.forEach((event) => {
            document.addEventListener(event, docListenerFn);
        });

        const intervalId = setInterval(() => {
            const isExpired = isSessionExpired();

            if (isExpired) {
                navigate('/inactivity', { replace: true });

                // Logout after a delay to avoid landing on login page
                setTimeout(() => {
                    dispatch(authActions.logout());
                }, 100);
            }
        }, 2000);

        return () => {
            clearInterval(intervalId);

            events.forEach((event) => {
                document.removeEventListener(event, docListenerFn);
            });
        };
    }, [dispatch, navigate, expiryInMinutes, token]);
};

export default useSession;
